import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const eventAssignedObjectListApi = createAsyncThunk(
  "auth/event/eventAssignedObjectList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AuthAxios.get(
        apiRoutes.publicapiAction('event-objects-by-event-id', 1),
        { params: data }
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
const initialState = { result: [], loading: false, error: null, message: "", total: 0 }
const eventAssignedObjectListSlice = createSlice({
  name: "event/eventAssignedObjectList",
  initialState,
  reducers: {
    reseteventAssignedObjectList: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(eventAssignedObjectListApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(eventAssignedObjectListApi.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.result ?? [];
      state.message = action?.payload?.message;
      state.total = action?.payload?.count
    });
    builder.addCase(eventAssignedObjectListApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});

export const { reseteventAssignedObjectList } = eventAssignedObjectListSlice.actions;
export const eventAssignedObjectListreducer = eventAssignedObjectListSlice.reducer;
